/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Edit_TracksInputs */



/**
* | output |
* | --- |
* | "Publishing edit results for individual tracks." |
*
* @param {Work_Order_Publish_Status_Edit_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_edit_tracks = /** @type {((inputs?: Work_Order_Publish_Status_Edit_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Edit_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication des résultats d’édition pour les pistes individuelles.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichungsergebnisse für die einzelnen Titel.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione dei risultati delle modifiche per singole tracce.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация результатов редактирования для отдельных треков.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación de resultados de edición para pistas individuales.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布各个曲目的编辑结果。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("個々のトラックの編集結果を公開します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अलग-अलग ट्रैक के लिए संपादन परिणाम प्रकाशित करना।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicando os resultados da edição para cada faixa individual.")
	return /** @type {LocalizedString} */ ("Publishing edit results for individual tracks.")
});